import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { BottomSns } from '../../common/BottomSnsImg';
import { mobileQuery, openAplLink } from '../../../utils';

export const RewardInfo = () => {
  return (
    <>
      <Wrap>
        <LabelRed>
          <LabelText>온라인 새틀라이트</LabelText>
        </LabelRed>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>새틀라이트</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              3월 11일(수) ~ 3월 27일(금)
              <br />
              매일 오후 8시
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.AppIcon} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <LabelBlue>
          <LabelText>오프라인 이벤트</LabelText>
        </LabelBlue>

        <EventRow>
          <FullText>APL TAIPEI 2026 MINI MAIN Day 1</FullText>

          <EventInfoRight>
            <EventDate>3월 28일(토)</EventDate>
            <EventVenueContainer>
              <EventVenue>오후 1시</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>

          <LocationContainer>
            <CircleLocation>ES Studio 수원</CircleLocation>
            <LocationText>경기 수원시 팔달구 인계로 94번길 27-27 2층</LocationText>
          </LocationContainer>
        </EventRow>

        <PartnerWrap>
          <PartnerContainer>
            <PartnerTitle>주최</PartnerTitle>
            <PartnerContent>
              <img src={ImageUtils.PartnerIcon1} alt="" />
            </PartnerContent>
          </PartnerContainer>

          <PartnerContainer>
            <PartnerTitle>협력</PartnerTitle>
            <PartnerContent>
              <img src={ImageUtils.PartnerIcon2} alt="" />
            </PartnerContent>
          </PartnerContainer>

          <RequestKakaoContainer>
            <RequestText>
              자세한 내용은 <br />
              <span onClick={openAplLink}>APL 공식 페이지에</span> <br />
              문의해주세요!
            </RequestText>

            <img src={ImageUtils.RequestIcon} alt="" />
          </RequestKakaoContainer>
        </PartnerWrap>
      </Wrap>
      <BottomSns />
    </>
  );
};

const Wrap = styled.div`
  text-align: center;
  padding-bottom: 150px;
  max-width: 820px;
  margin: 0 auto;
  padding-top: 40px;

  ${mobileQuery} {
    padding-top: 15px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const Label = styled.div`
  height: 42px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 26px;
  }
`;

const LabelRed = styled(Label)`
  border-top: 1px solid #e37ac9;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
`;

const LabelBlue = styled(Label)`
  border-top: 2px solid #cba65f;
  background: #967d4b;
`;

const LabelText = styled.p`
  font-weight: 500;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 26px;
  }
`;

const FullText = styled.h3`
  color: #00ffd4;
  font-size: 26px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: -1.04px;
  margin-bottom: 10px;
  text-align: left;
  align-self: flex-start;
  padding-top: 10px;

  ${mobileQuery} {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 5px;
    padding-top: 5px;
  }
`;

const EventRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  text-align: left;
  margin-bottom: 2px;
  background-color: #222;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }

  ${mobileQuery} {
    padding: 0px 10px;
    padding-top: 5px;
    padding-bottom: 6px;
  }
`;

const EventInfoLeft = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const EventInfoRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const EventTitleRed = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #ff63a2;

  ${mobileQuery} {
    font-size: 16px;
  }
`;

const EventDate = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  span {
    font-weight: 700;
  }

  ${mobileQuery} {
    font-size: 15px;
  }
`;

const EventVenueContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  img {
    display: none;
  }

  ${mobileQuery} {
    img {
      display: block;
      width: 34px;
      margin-bottom: 2px;
    }
  }
`;

const EventVenue = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 13px;
  }
`;

const RequestKakaoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px;

  border-top: 2px solid rgba(0, 0, 0, 0.5);

  border-bottom: 2px solid rgba(0, 0, 0, 0.5);

  background: #222;

  height: 170px;
  flex: 1;

  ${mobileQuery} {
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    padding-left: 15px;
    padding-right: 15px;
    height: 85px;
    img {
      width: 30px;
    }
  }
`;
const RequestText = styled.p`
  text-align: left;
  margin-right: 30px;

  color: rgba(255, 255, 255, 0.8);
  font-family: 'Noto Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 125% */

  span {
    color: #cba65f;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6%;
    text-underline-offset: 20%;
    cursor: pointer;
  }

  ${mobileQuery} {
    margin-right: 15px;
    font-size: 12px;
    line-height: 15px;

    span {
      font-size: 12px;
      line-height: 15px;
    }
  }
`;

const PartnerWrap = styled.div`
  display: flex;
`;

const PartnerContainer = styled.div`
  width: 154px;
  margin-right: 2px;
  margin-bottom: 2px;
  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    width: 93px;
  }
`;

const PartnerTitle = styled.h3`
  height: 40px;

  border-bottom: 1px solid #000000;
  background: rgba(0, 0, 0, 0.5);

  font-family: 'Gmarket';

  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.8px;
  line-height: 40px;

  ${mobileQuery} {
    font-size: 10px;
    line-height: 20px;
    height: 20px;
  }
`;

const PartnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 130px;

  background: rgba(0, 0, 0, 0.2);

  ${mobileQuery} {
    height: 65px;
    img {
      width: 54px;
    }
  }
`;

const LocationContainer = styled.div`
  display: flex;
  align-self: flex-start;
  margin-top: 10px;
  margin-bottom: 30px;

  ${mobileQuery} {
    margin-bottom: 4px;
  }
`;

const CircleLocation = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0);
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  margin-right: 10px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 16px;
    padding-left: 10px;
    padding-right: 10px;
    margin-right: 5px;
    padding-top: 2px;
    padding-bottom: 4px;
  }
`;
const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  font-weight: 400;
  line-height: 30px; /* 125% */
  letter-spacing: -0.96px;

  ${mobileQuery} {
    font-size: 14px;
    line-height: 22px;
  }
`;
